import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOutreachTemplate = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 13,
	viewBox: "0 0 14 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.624695 9.96863V3.03113H7.5622V9.96863H0.624695ZM1.74969 8.84363H6.4372V4.15613H1.74969V8.84363ZM0.624695 1.24988V0.124878H13.3747V1.24988H0.624695ZM9.20638 4.15613V3.03113H13.3747V4.15613H9.20638ZM9.20638 7.06238V5.93738H13.3747V7.06238H9.20638ZM9.20638 9.96863V8.84363H13.3747V9.96863H9.20638ZM0.624695 12.8749V11.7499H13.3747V12.8749H0.624695Z",
		fill: "#707684"
	})
});
export default SvgOutreachTemplate;
